import React, { useEffect } from "react";
import AddUserForm from "./AddUserForm.js";

export default function AddUserModal({ onClose, onSave }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return React.createElement(
    "div",
    {
      className: "modal-backdrop",
      role: "dialog",
      "aria-modal": true,
      onClick: (e) => e.target === e.currentTarget && onClose(),
    },
    React.createElement(
      "div",
      { className: "modal" },
      React.createElement(
        "div",
        { className: "modal-header" },
        React.createElement("h3", null, "Add User"),
        React.createElement(
          "button",
          { className: "icon-btn", onClick: onClose, "aria-label": "Close" },
          "✕"
        )
      ),
      React.createElement(
        "div",
        { className: "modal-body" },
        React.createElement(AddUserForm, { onCancel: onClose, onSave })
      )
    )
  );
}
